export const LANDING = {
  navLogo: "landing-nav-logo",
  navLinkHome: "landing-nav-link-home",
  navLinkPhilosophy: "landing-nav-link-philosophy",
  navLinkBook: "landing-nav-link-book",
  navLinkContact: "landing-nav-link-contact",
  navLinkEchoes: "landing-nav-link-echoes",
  
  langToggleEn: "landing-lang-toggle-en",
  langToggleDe: "landing-lang-toggle-de",
  
  heroTitle: "landing-hero-title",
  heroSubtitle: "landing-hero-subtitle",
  heroBookCta: "landing-hero-book-cta",
  heroContactCta: "landing-hero-contact-cta",
  heroPortrait: "landing-hero-portrait",
  
  philosophyTitle: "landing-philosophy-title",
  philosophyCardConnection: "landing-philosophy-card-connection",
  philosophyCardMusicality: "landing-philosophy-card-musicality",
  philosophyCardTechnique: "landing-philosophy-card-technique",
  
  bookTitle: "landing-book-title",
  bookCoverImg: "landing-book-cover-img",
  bookBuyBtn: "landing-book-buy-btn",
  
  contactTitle: "landing-contact-title",
  contactEmailLink: "landing-contact-email-link",
  
  impressumLink: "landing-impressum-link",
  impressumModal: "landing-impressum-modal",
  impressumCloseBtn: "landing-impressum-close-btn",

  datenschutzLink: "landing-datenschutz-link",
  datenschutzModal: "landing-datenschutz-modal",
  datenschutzCloseBtn: "landing-datenschutz-close-btn",
  
  cookieNoticeText: "landing-cookie-notice-text",

  // Echoes guestbook section
  echoesTitle: "landing-echoes-title",
  echoesForm: "landing-echoes-form",
  echoesInputName: "landing-echoes-input-name",
  echoesInputMessage: "landing-echoes-input-message",
  echoesSubmitBtn: "landing-echoes-submit-btn",
  echoesList: "landing-echoes-list",
  echoesItem: "landing-echoes-item",
};
